/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_SocialInputs */

const en_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

const zh_hans1_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社交`)
};

const pt_br2_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

const es_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redes sociales`)
};

const fr_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseaux sociaux`)
};

const de_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

const ru_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соцсети`)
};

const it_category_social = /** @type {(inputs: Category_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social`)
};

/**
* | output |
* | --- |
* | "Social" |
*
* @param {Category_SocialInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_social = /** @type {((inputs?: Category_SocialInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_SocialInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_social(inputs)
	if (locale === "pt-BR") return pt_br2_category_social(inputs)
	if (locale === "es") return es_category_social(inputs)
	if (locale === "fr") return fr_category_social(inputs)
	if (locale === "de") return de_category_social(inputs)
	if (locale === "ru") return ru_category_social(inputs)
	if (locale === "it") return it_category_social(inputs)
	return en_category_social(inputs)
});